/**
 * Paging read from the URL (ZTA design evaluation F7/F24, Phase 3).
 *
 * List pages keep `page` (1-based) and `rows` in the URL through useUrlState,
 * as strings. These read them back as numbers a query can use, falling back to
 * the first page and the default size when the URL holds something unusable
 * (a hand-edited `?page=abc`, or a size the picker doesn't offer).
 *
 * Every server-side filter change writes `page: null` alongside it, so a
 * narrower filter starts again at page 1 instead of an empty page 3.
 */
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100] as const;
export const DEFAULT_ROWS_PER_PAGE = 20;

/** The 1-based page in `raw`, or 1. */
export function readPage(raw: string | null | undefined): number {
  const n = Number.parseInt(raw ?? '', 10);
  return Number.isFinite(n) && n >= 1 ? n : 1;
}

/** The page size in `raw` when it is one of `options`, else `fallback`. */
export function readRows(
  raw: string | null | undefined,
  fallback: number = DEFAULT_ROWS_PER_PAGE,
  options: readonly number[] = ROWS_PER_PAGE_OPTIONS,
): number {
  const n = Number.parseInt(raw ?? '', 10);
  return options.includes(n) ? n : fallback;
}

/** The server offset of a 1-based page. */
export const pageOffset = (page: number, rows: number): number => (Math.max(1, page) - 1) * rows;
